import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

import { FormSubGroup, FormSubGroupHeading, ImageWrapper, Section, SectionColumn } from '../../../components/layout'
import { SelectInput, TextAreaInput, TextInput } from '../../../components/layout/form/input'
import {
  DateSectionColumn,
  HalfDateInput,
  HalfTimeInput,
} from '../../../containers/TowingOrderPage/EditTowingOrder/TowingOrderDetailsSubFormContents'
import lahitapiola from '../../../images/lahitapiola.png'
import { LahitapiolaFormSubGroupHeader, LahitapiolaFormSubGroupWrapper } from '../components'
import { useSettings } from '../../../containers/Parameters'
import { formatMessageSafe } from '../../../util/translateInputOptions'
import { messages } from '../messages'

interface FormContentsProps {
  isTowingRecord?: boolean
}

const HalfTextInput = styled(TextInput as any)`
  width: calc(50% - 1rem);
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    width: calc(50% - 0.125rem);
  }
`

export const LahitapiolaDefaultOrderDetailsForm: React.FunctionComponent<FormContentsProps> = ({ isTowingRecord }) => {
  const settings = useSettings()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  if (!settings) {
    return null
  }

  return (
    <LahitapiolaFormSubGroupWrapper>
      <LahitapiolaFormSubGroupHeader>
        <FormSubGroupHeading>
          <ImageWrapper>
            <img src={lahitapiola} alt="Lähitapiola" width={`95px`} />
          </ImageWrapper>
        </FormSubGroupHeading>
      </LahitapiolaFormSubGroupHeader>
      <FormSubGroup>
        <Section columns={2} marginMobile="0">
          <DateSectionColumn>
            <HalfDateInput label={formatMessage(messages.date)} name="jobDetails.towingDate" required disabled={isTowingRecord} />
            <HalfTimeInput label={formatMessage(messages.time)} name="jobDetails.towingTime" disabled={isTowingRecord} />
          </DateSectionColumn>
          <SectionColumn />
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <SelectInput
              label={formatMessage(messages.towingReason)}
              name="jobDetails.towingReason"
              options={settings.towingReasons.map((label: string) => ({
                label,
                value: label,
              }))}
            />
          </SectionColumn>
          <DateSectionColumn>
            <HalfTextInput label={formatMessage(messages.caseNumber)} name="automobileAndTouringClubFinland.caseNumber" disabled />
            <HalfTextInput label={formatMessage(messages.billingInfo)} name="automobileAndTouringClubFinland.billingInfo" disabled />
          </DateSectionColumn>
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <TextAreaInput label={formatMessage(messages.additionalInfo)} name="jobDetails.additionalInfo" />
          </SectionColumn>
          <SectionColumn>
            <TextAreaInput label={formatMessage(messages.notes)} name="jobDetails.notes" />
          </SectionColumn>
        </Section>
        {/* <Section columns={2}>
          <SectionColumn>
            <TextAreaInput label="Tilannearvio" name="automobileAndTouringClubFinland.situationDescription" disabled />
          </SectionColumn>
          <SectionColumn />
        </Section> */}
      </FormSubGroup>
    </LahitapiolaFormSubGroupWrapper>
  )
}
